import { PlatformLanguageCode } from "./platform-language-code";
import { PictureFormat } from "./picture-format";

export class PictureOptionCouple {
  id: number = 0;
  language: PlatformLanguageCode | null = null;
  format: PictureFormat | null = null;
  isAvailable: boolean = false;
  isLocalized: boolean = false;
  isOriginalVersion: boolean = false;
  contentSubType: string | null = null;
  contentType: string | null = null;
  contentId: number = 0;
  concernedAssetIds: number[] | null = [];

  constructor(init?: Partial<PictureOptionCouple>) {
    Object.assign(this, init);
  }
}
